export const formatCounterNumber = (value: number, padString = "0"): string => {
  return value.toString().padStart(2, padString)
}
